import React, { Component } from 'react';
import qs from 'qs';
import _ from 'lodash';
import { t } from 'utils/translates';
import {
  selectItemById,
  selectItemsIds,
  selectPagination,
  selectRequestState,
  sendRequest,
  changeQueryParams,
  selectTotal
} from 'mt-react-common/common/reducers/list/reducer';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import UserReferralTableItem from './UserReferralTableItem';
import PaginationBlock from '../../Common/Pagination/PaginationBlock/PaginationBlock';
import OpacityPreLoader from '../../Common/PreLoaders/OpacityPreLoader';
import DateRangeInput from '../../Common/Inputs/DateRangeInput/DateRangeInput';
import SearchInput from '../../Common/Inputs/SearchInput';
import SortLabelColumnToggle from '../../Common/Inputs/SortLabelColumnToggle';

const userReferralStatListRN = 'userReferralModule.lists.userReferralStatList';

class UserReferralTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      queryParams: {
        page: 1,
        sort: 'reg_at',
        referral_search: null,
        dateFrom: null,
        dateTo: null
      },
      queryParamsStatic: {}
    };
    this.state = {
      queryParams: { ...this.state.queryParams }
    };
    this.sendRequest();
  }

  componentDidUpdate(prevProps) {
    if (
      !_.isEqual(
        qs.parse(this.props.location.search.slice(1))[this.props.blockName],
        qs.parse(prevProps.location.search.slice(1))[this.props.blockName]
      ) &&
      this.props.location.pathname === prevProps.location.pathname &&
      this.props.location.hash === prevProps.location.hash
    ) {
      console.log(
        qs.parse(this.props.location.search.slice(1))[this.props.blockName]
      );
      this.sendRequest();
    }
  }

  setQueryParams = queryParams => {
    this.state.queryParams = { ...this.state.queryParams, ...queryParams };
    this.props.changeQueryParams({
      ...this.state.queryParams,
      ...this.state.queryParamsStatic
    });
  };

  setGroupQueryParamsAndUpdateHistory = () => {
    this.props.setGroupQueryParamsAndUpdateHistory({
      [this.props.blockName]: this.state.queryParams
    });
  };

  sendRequest = () => {
    this.setQueryParams(
      qs.parse(this.props.location.search.slice(1))[this.props.blockName]
    );
    this.props.sendRequest();
  };

  render() {
    let items = null;
    if (this.props.itemsIds.length > 0) {
      items = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            <UserReferralTableItem item={this.props.selectItemById(itemId)} />
          ))}
        </React.Fragment>
      );
    } else {
      items = (
        <tr>
          <td className="text-center" colSpan="5">
            {t('Пользователи не найдены')} :-(
          </td>
        </tr>
      );
    }
    return (
      <div>
        {this.props.requestState.inProgress ? <OpacityPreLoader /> : null}
        <form
          className="form-inline ng-pristine ng-valid ng-touched"
          noValidate=""
        >
          <div className="form-group">
            <label className="sr-only" htmlFor="referralSearch">
              {t('Поиск')}
            </label>
            <SearchInput
              type="search"
              className="form-control ng-pristine ng-valid ng-touched"
              id="referralSearch"
              placeholder={t('Поиск')}
              onChange={e => {
                this.setQueryParams({
                  page: 1,
                  referral_search: e.target.value
                });
                this.setGroupQueryParamsAndUpdateHistory();
              }}
              value={this.state.queryParams.referral_search}
            />
          </div>
          <DateRangeInput
            placeholder={t('По дату')}
            startValueFrom={this.state.queryParams.dateFrom}
            startValueTo={this.state.queryParams.dateTo}
            idElement={`${this.props.blockName}-dataRange`}
            handleChangeRangeValues={range => {
              this.setQueryParams({
                page: 1,
                dateFrom: range.valueFrom,
                dateTo: range.valueTo
              });
              this.setGroupQueryParamsAndUpdateHistory();
            }}
          />
          <div className="form-group">
            {t('За выбранный период')}:{' '}
            <span
              className="text-primary"
              data-original-title={t('Рефералы')}
              data-placement="top"
              data-referral="users"
              data-toggle="tooltip"
              title=""
            >
              <i className="fa fa-user" />{' '}
              <span className="val">{this.props.total.countReferral}</span>
            </span>
            ,{' '}
            <span
              className="text-success"
              data-original-title={t('Деньги')}
              data-placement="top"
              data-referral="money"
              data-toggle="tooltip"
              title=""
            >
              <i className="fa fa-rub" />{' '}
              <span className="val">{this.props.total.sumMoney}</span>
            </span>
          </div>
        </form>
        <div className="table-responsive">
          <table className="table table-sortible table-hover m-b-0">
            <thead>
              <tr>
                <th className="no-sort">{t('Пользователь')}</th>
                <SortLabelColumnToggle
                  label={t('Дата регистрации')}
                  tag="th"
                  defaultValue="reg_at"
                  className="text-center"
                  selectedValue={this.state.queryParams.sort}
                  handleChangeSortValue={sortValue => {
                    this.setQueryParams({
                      sort: sortValue
                    });
                    this.setGroupQueryParamsAndUpdateHistory();
                  }}
                />
                <SortLabelColumnToggle
                  label={t('Уровень')}
                  tag="th"
                  defaultValue="level"
                  className="text-center"
                  selectedValue={this.state.queryParams.sort}
                  handleChangeSortValue={sortValue => {
                    this.setQueryParams({
                      sort: sortValue
                    });
                    this.setGroupQueryParamsAndUpdateHistory();
                  }}
                />
                <SortLabelColumnToggle
                  label={`${t('Деньги')}, <i class="fa fa-rub" />`}
                  tag="th"
                  defaultValue="money"
                  className="text-right"
                  selectedValue={this.state.queryParams.sort}
                  handleChangeSortValue={sortValue => {
                    this.setQueryParams({
                      sort: sortValue
                    });
                    this.setGroupQueryParamsAndUpdateHistory();
                  }}
                />
              </tr>
            </thead>
            <tbody>{items}</tbody>
          </table>
        </div>
        <div className="table-footer">
          <PaginationBlock
            paginationData={this.props.pagination}
            handlePageClick={pageNumber => {
              this.setQueryParams({ page: pageNumber });
              this.setGroupQueryParamsAndUpdateHistory();
            }}
          />
        </div>
      </div>
    );
  }
}

UserReferralTable.contextTypes = {
  router: PropTypes.shape()
};

UserReferralTable.propTypes = {
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,

  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  selectItemById: PropTypes.func.isRequired,
  total: PropTypes.shape({
    countReferral: PropTypes.number,
    sumMoney: PropTypes.string
  }).isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired,

  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,

  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
    hash: PropTypes.string.isRequired
  }).isRequired,

  // Component props
  blockName: PropTypes.string.isRequired,
  setGroupQueryParamsAndUpdateHistory: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, userReferralStatListRN),
  pagination: selectPagination(state, userReferralStatListRN),
  itemsIds: selectItemsIds(state, userReferralStatListRN),
  selectItemById: id => selectItemById(state, userReferralStatListRN, id),
  total: selectTotal(state, userReferralStatListRN)
});

const mapDispatchToProps = dispatch => ({
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(userReferralStatListRN, queryParams)),
  sendRequest: () => dispatch(sendRequest(userReferralStatListRN))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserReferralTable)
);



// WEBPACK FOOTER //
// ./src/components/UserReferral/UserReferralTable/UserReferralTable.js